import styled from 'styled-components'

export const ContainerPontosAdicionados = styled.div`
  width: 100%;
  height: auto;

  .ant-collapse-content-box {
    padding: 10px !important;
  }

  .container__adicionados {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 8px;
    gap: 5px;
  }

  .header__adicionados {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nome__analise {
      padding: 7px;
      font-size: 11px;
      font-weight: 700;
      color: white;
      border-radius: 5px;
    }
  }

  .points-title {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .points-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .point-card {
    background-color: var(--cor-do-item);
    color: white;
    border: 2px solid var(--cor-do-item);
    font-weight: 700;
    font-size: 12px;
    width: 30px !important;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }

  .point-card:hover {
    transition: 0.5s;
    transform: scale(1.05);
    background-color: var(--cor-do-item);
    border: 2px solid var(--cor-do-item);
    color: white;
  }
`
